import * as React from "react";
import Paper from "@mui/material/Paper";
import { layoutStyle } from "./style";
import { Typography, Container, Box, Button, Drawer } from "@mui/material";
import { useCompany, useUser, useColor, useTheme } from "../../common/hooks";
import { localStorageItemNames } from "../../common/constants";
import { showToast } from "../../components/Toast";
import { SupportModal } from "../../components/SupportModal";
const Footer = () => {
  const [value, setValue] = React.useState(0);
  const classes = layoutStyle();
  const { colorFooter } = useColor();
  const { currentTheme } = useTheme();
  const [openSupport, setOpenSupport] = React.useState(false);
  const { getUserById, userData } = useUser();
  React.useEffect(() => {
    const userId = localStorage.getItem(localStorageItemNames.userID);
    if (userId && !userData) {
      getUserById(userId);
    }
  }, [getUserById, userData]);

  const handleOpenSupport = () => {
    setOpenSupport(true);
  };
  return (
    <>
      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: colorFooter || currentTheme?.palette?.background?.paper,
          borderTop: `1px solid var(--divider)`,
          backdropFilter: "blur(20px)",
          boxShadow:
            currentTheme?.palette?.mode === "dark"
              ? "0 -8px 24px rgba(0,0,0,0.45)"
              : "0 -8px 24px rgba(2, 6, 23, 0.04)",
        }}
        elevation={0}
      >
        <Box
          sx={{ background: "transparent", height: 50, display: "flex", alignItems: "center" }}
        >
          <Container maxWidth="100%">
            <Box className={classes.footerNav}>
              <Box className={classes.widthFooterVersion}>
                <div className={classes.footerVersionDiv}>
                  <span style={{ color: currentTheme?.palette?.text?.secondary, fontSize: 12 }}>
                    &#169; Copyright 2026 Vehicle Data Analysis Tool. All rights reserved.
                  </span>
                </div>
              </Box>
            </Box>
          </Container>
        </Box>
      </Paper>
      {userData && openSupport && (
        <SupportModal
          close={() => setOpenSupport(false)}
          open={openSupport}
          userData={userData}
        />
      )}
    </>
  );
};

export default Footer;
